import React, { Component } from "react";
import ViewsTable from "../../../../components/tables/ViewsTable";
import FieldModal from "../../../../components/modals/fieldModal";
import InputField from "../../../../components/inputs/inputField";
import { UncontrolledTooltip } from 'reactstrap';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment-timezone';
import API from '../../../../utils/API';
import DeleteSubmissionModal from '../../forms/modals/deleteSubmissionModal';

const submissionTypes = {
    checkInForm: "eventCheckin",
    walkInForm: "walkInCheckin",
    sessionCheckInForm: "sessionCheckin",
}

class FormSubmissionsModal extends Component {
    constructor(props) {
        let columns = {
            email: "Email",
            firstName: "First Name",
            lastName: "Last Name",
            submittedAt: "Submitted",
            source: "Source",
        };


        let columnTypes = {
            email: "text",
            firstName: "text",
            lastName: "text",
            submittedAt: "timestamp",
            source: "text",
        };

        if (props.formType === "sessionCheckInForm") {
            columns.selectedSession = "Session";
            columnTypes.selectedSession = "text";
        }

        if(props.documentSigningEnabled) {
            columns.signedDocument = "Signed Document";
            columnTypes.signedDocument = "document";
        }


        const toggledColumns = {};
        let normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false,
            };
        });

        const toggledFieldLabels = { ...toggledColumns };
        const normalizedFieldLabels = [...normalizedColumns];
        props.form.pages.forEach((page) => {
            page.sections.forEach((section) => {
                section.fields.forEach((field) => {
                    toggledFieldLabels[field.id] = true;
                    normalizedFieldLabels.push({
                        key: field.id,
                        label: field.label,
                        type: field.type,
                        value: field.id,
                        sortAsc: false,
                        sortDesc: false,
                    });

                    if (field.type == "nestedSections") {
                        field.nestedSections.forEach((nestedSection) => {
                            nestedSection.questions.forEach((question) => {
                                toggledFieldLabels[question.id] = true;
                                normalizedFieldLabels.push({
                                    key: question.id,
                                    label: question.label,
                                    type: question.type,
                                    value: question.id,
                                    sortAsc: false,
                                    sortDesc: false,
                                });
                            });
                        });
                    }
                });
            });
        });

        props.event.customFields.attendees.forEach((cfcategory) => {
            cfcategory.fields.forEach((field) => {
                columns[field._id] = field.fieldName;
                columnTypes[field._id] = field.fieldType;
                toggledColumns[field._id] = true;

                let attendeeCustomField = {
                    label: field.fieldName,
                    key: field._id,
                    value: field._id,
                    type: field.fieldType,
                    sortAsc: false,
                    sortDesc: false,
                };
                normalizedColumns.push(attendeeCustomField);
            });
        });

        super(props);
        this.state = {
            loading: false,
            columns: columns,
            columnTypes: columnTypes,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            normalizedFieldLabels: normalizedFieldLabels,
            toggledFieldLabels: toggledFieldLabels,
            checkedSubmission: {},
            submissionDetailsModalTrigger: false,
            selectedColumnSort: null,
            sortDesc: false,
            searchTerm: "",
            searching: false,
            checkedSubmission: {},
            deleteSubmissionModalOpen: false,
            isDeleting: false,
        };
    }

    componentDidMount() {
        const { columnTypes, columns } = this.state;
        const { form, formType, event } = this.props;
        let customFieldColumns = [];
        let customFieldColumnTypes = [];
        event.customFields.attendees.forEach((category) => {
            category.fields.forEach((f) => {
                customFieldColumns[f._id] = f.fieldName;
                customFieldColumnTypes[f._id] = f.fieldType;
            });
        });
        let att = form.submissions.map((a) => {
            if (a.formData.submissionType && a.formData.submissionType === submissionTypes[formType] && !a.deleted) {

                let extraFields =
                    typeof a.formData.extraFields == "string"
                        ? JSON.parse(a.formData.extraFields)
                        : a.formData.extraFields;
                const timezone = this.props.event && this.props.event.timezone;
                const sub = {
                    _id: a._id,
                    firstName:
                        a.attendee.firstName === "-"
                            ? a.formData.firstName || "-"
                            : a.attendee.firstName,
                    lastName:
                        a.attendee.lastName === "-"
                            ? a.formData.lastName || "-"
                            : a.attendee.lastName,
                    email:
                        a.attendee.email === "-" ? a.formData.email || "-" : a.attendee.email,
                    // convert submittedAt to the event's timezone 
                    submittedAt: a.submittedAt ? moment.tz(a.submittedAt, timezone).format('MM/DD/YYYY h:mm a') : '',
                    source: form.name,
                    ...extraFields,
                    ...a.formData,
                };


                if (this.props.formType === "sessionCheckInForm") {
                    const session = event.sessions.find((s) => s._id === a.formData.selectedSession);
                    sub.selectedSession = session ? session.name : "";
                }

                if(this.props.documentSigningEnabled && a.formData.signedDocumentId) {
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url
                    sub.signedDocument = <a href="javascript:void(0)" onClick={() => this.downloadBoldsignDocument(a.formData.signedDocumentId, sub.email)}>Download</a>;
                }

                return sub;
            }

            return null
        }).filter((a) => a != null);

        this.setState({
            loading: false,
            formSubmissions: att,
            columns: { ...columns, ...customFieldColumns },
            columnTypes: { ...columnTypes, ...customFieldColumnTypes },
        });
    }

    sortData = (column, sortAsc, sortDesc) => {
        const { normalizedColumns } = this.state;
        const updatedColumns = normalizedColumns.map((col) => {
            if (col.key == column.key) {
                col.sortAsc = sortAsc;
                col.sortDesc = sortDesc;
            } else {
                col.sortAsc = false;
                col.sortDesc = false;
            }
            return col;
        });

        this.setState({
            normalizedColumns: updatedColumns,
            selectedColumnSort: column,
            sortDesc: sortDesc ? true : false,
        });
    };
    searchEntries = (searchText) => {
        this.setState({
            searching: searchText != "" ? true : false,
            searchText: searchText ? searchText : "",
        });
    };
    s2ab = (s) => {
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf); //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
        return buf;
    };
    download = (attList) => {
        const columns = this.state.normalizedFieldLabels.reduce((acc, cur) => {
            acc[cur.key] = cur.label;
            return acc;
        }, {});
        const headers = Object.values(columns);
        const rows = attList.map(sub => {
            return Object.keys(columns).map(key => {
                if (key === 'submittedAt' && sub[key]) {
                    return moment(sub[key]).format('MM/DD/YYYY h:mm a');
                }
                return (sub[key] || sub[key] === '') ? sub[key] : '';
            });
        });

        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title: 'Form Submission',
            Subject: 'Submissions',
            Author: 'Simple Events',
            CreatedDate: new Date()
        };
        wb.SheetNames.push('Data');
        /* make worksheet */
        var ws_data2 = [headers, ...rows];
        var ws2 = XLSX.utils.aoa_to_sheet(ws_data2);

        /* Add the worksheet to the workbook */
        wb.Sheets['Data'] = ws2;

        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        saveAs(
            new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
            `${this.props.form.name} Submissions.xlsx`
        );
    };

    updatedCheckedSubmissions = (checked) => {
        this.setState({ checkedSubmission: checked });
    };
    clearCheckedSubmissions = () => {
        this.setState({ checkedSubmission: {} });
    };
    handleRowCheck = (entryId) => {
        const checked = { ...this.state.checkedSubmission };

        if (checked[entryId]) {
            delete checked[entryId];
        } else {
            checked[entryId] = true;
        }

        this.setState({ checkedSubmission: checked },
            () => this.updateSubmissionEditing()
        );
    };

    downloadBoldsignDocument = (documentId, attendeeEmail) => {
        const { orgId, eventId } = this.props;
        API()
            .get(`Organizations/${orgId}/events/${eventId}/downloadSignedDocument/${documentId}`, {
                responseType: 'blob',
            })
            .then((res) => {
                const blob = new Blob([res.data], { type: 'application/pdf' });
                saveAs(blob, `signed_document_${attendeeEmail}.pdf`);
            })
            .catch((e) => {
                console.log('Error downloading document:', e);
            });
    }

    handleAllRowsCheck = (entryIds) => {
        let checked = {};

        if (entryIds.length > 0) {
            entryIds.forEach((entryId) => {
                checked[entryId] = true;
            });
        }

        this.setState({ checkedSubmission: checked },
            () => this.updateSubmissionEditing()
        );
    };
    updateSubmissionEditing = () => {
        const { checkedSubmission } = this.state;
        const hasCheckedItems = Object.keys(checkedSubmission).length > 0;

        if (hasCheckedItems) {
            this.props.toggleSubmissionEditing &&
                this.props.toggleSubmissionEditing(
                    true,
                    checkedSubmission,
                    this.clearCheckedSubmissions
                );
        } else {
            this.props.toggleSubmissionEditing && this.props.toggleSubmissionEditing(false);
        }
    };

    toggleDeleteSubmission = () => {
        this.setState({ deleteSubmissionModalOpen: !this.state.deleteSubmissionModalOpen });
    };

    deleteFormSubmission = async (callback) => {
        const { orgId, eventId, form, pin } = this.props;
        const { checkedSubmission, formSubmissions } = this.state;

        if (Object.keys(checkedSubmission).length > 0) {
            this.setState({ isDeleting: true });
            await API()
                .post(`Organizations/${orgId}/events/${eventId}/deleteSubmissions`, {
                    deletedSubmissions: Object.keys(checkedSubmission),
                })
                .then((res) => {
                    if (res.data) {
                        const updatedSubmissions = formSubmissions.filter(
                            (sub) => !checkedSubmission[sub._id]
                        );
                        this.setState(
                            { formSubmissions: updatedSubmissions, checkedSubmission: {}, isDeleting: false },
                            () => {
                                this.props.toggleSubmissionEditing &&
                                    this.props.toggleSubmissionEditing(false);
                                callback && callback();
                            }
                        );
                    }
                })
                .catch((e) => {
                    console.log(e);
                    this.setState({ isDeleting: false });
                    callback && callback();
                });
        }
    };

    render() {
        const { isOpen, form } = this.props;

        const {
            normalizedFieldLabels,
            toggledFieldLabels,
            searchTerm,
            formSubmissions,
            checkedSubmission,
            deleteSubmissionModalOpen,
            isDeleting,
        } = this.state;

        const hasCheckedItems = Object.keys(checkedSubmission).length > 0;
        console.log('Submissions:', formSubmissions);
        return (<FieldModal
                    isFullWidthBody={true}
                    size="large"
                    modalTitle={`Form Submissions`}
                    isOpen={isOpen}
                    bodyDescription={""}
                    bodyContent={() => {
                        return (
                            <div className="h-100">
                                <div className="actionButtonContainer  flex-ac">
                                    {/* Search filed */}

                                    <div className="mb-10  mt-10 flex aic">
                                        <InputField
                                            classes="m-0 viewSearch"
                                            placeholder="Search "
                                            clickIcon={true}
                                            required={true}
                                            value={searchTerm}
                                            onChange={(e) => {
                                                clearTimeout(this.searchTimeout);
                                                this.setState({ searchTerm: e.target.value }, () => {
                                                    this.searchTimeout = setTimeout(
                                                        () => this.searchEntries(this.state.searchTerm),
                                                        1000
                                                    );
                                                });
                                            }}
                                            prefix={
                                                <i
                                                    className="las la-search"
                                                    style={{ marginRight: 5, transform: "rotate(270deg)" }}
                                                />
                                            }
                                            inputIcon={
                                                searchTerm != "" && (
                                                    <i
                                                        onMouseDown={() =>
                                                            this.setState(
                                                                { searchTerm: "", searching: false },
                                                                () => this.searchEntries("")
                                                            )
                                                        }
                                                        //onClick={() => this.setState({ searchTerm: '', searching: false })}
                                                        className="las la-times-circle"
                                                        style={{
                                                            visibility: searchTerm == "" ? "hidden" : "visible",
                                                        }}
                                                    />
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="sectionOptionsContainer">
                                        <div id="downloadTable" className='c-pointer fs-20' onClick={() => this.download(formSubmissions)}>
                                            <i className="las la-download" />
                                            <UncontrolledTooltip target="downloadTable" placement="left">Download Table Data</UncontrolledTooltip>
                                        </div>
                                    </div>
                                </div>

                                <ViewsTable
                                    title={"Submissions"}
                                    style={{ margin: 0 }}
                                    noDescription={true}
                                    columns={normalizedFieldLabels}
                                    toggledColumns={toggledFieldLabels}
                                    data={formSubmissions || []}
                                    mainColumnActive={false}
                                    checkRow={this.handleRowCheck}
                                    checkAllRows={this.handleAllRowsCheck}
                                    sortData={this.sortData}
                                    checked={checkedSubmission}
                                />

                                {deleteSubmissionModalOpen && (
                                    <DeleteSubmissionModal
                                        isOpen={deleteSubmissionModalOpen}
                                        toggle={this.toggleDeleteSubmission}
                                        deleteSubmission={this.deleteFormSubmission}
                                        selectedSubmissionCount={Object.keys(checkedSubmission).length}
                                    />
                                )}
                            </div>
                        );
                    }}
                    toggle={this.props.toggle}
                    cancelButtonLabel={"Close"}
                    actionButtonLabel={hasCheckedItems ? "Delete Selected" : undefined}
                    actionButton={hasCheckedItems ? this.toggleDeleteSubmission : undefined}
                    actionButtonDisabled={isDeleting}
                    isDelete={hasCheckedItems}
                />
        );
    }
}

export default FormSubmissionsModal;
